export const matchmaking = {
  modal: {
    title: 'Matchmaking',
  },
  search: {
    defaultMessage: 'Searching for a player...',
    searchingForOpponent: 'Searching for opponent...',
    startingFreePlay: 'Starting free play...',
    longWait:
      'It looks like there may be no players at your level or stake right now. Please try again later.',
    restoring: 'Restoring matchmaking...',
    waitingForOpponent: 'Waiting for opponent to accept...',
    loadingGame: 'Loading game...',
    cancel: 'Cancel',
    cancelSearch: 'Cancel search',
    cancelledTitle: 'Search cancelled',
    cancelledMessage: 'Your search has been cancelled',
  },
  stake: {
    findOpponent: 'Find opponent',
    freePlay: 'Free play',
    freePlayOr: 'or play with bot',
    insufficientBalance: 'Insufficient balance',
    entryFeeRange: 'Entry fee must be between {{min}} and {{max}}',
    nextLeague: 'Win {{count}} more games to unlock higher-tier tournaments',
    averageEntryFee: 'Average entry fee {{amount}}$',
    players: '{{count}} Players',
    optionWin: 'win {{amount}}',
    updatedEntryFee: 'Updated entry fee',
    entryFeeDeclined: 'Entry fee update declined',
    entryFeeDeclinedMessage:
      'The updated entry fee was declined. Search continues...',
    difficulty: {
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
    },
  },
  confirm: {
    gameFound: 'Game found!',
    opponent: 'Opponent: {{name}}',
    acceptWithin: 'Accept within {{time}}',
  },
  result: {
    win: {
      congratulations: 'Congratulations!',
      title: 'You win!',
      payout: 'You won {{amount}} $',
    },
    lose: {
      subtitle: 'Oh, no...',
      title: 'You lose',
    },
    draw: {
      subtitle: 'No winner this time',
      title: 'Draw!',
    },
    playAgain: 'Play again',
    findNewOpponent: 'Find new opponent',
    rematch: 'Rematch',
  },
  rematch: {
    waiting: 'Waiting for your opponent to accept the rematch...',
    back: 'Back',
  },
  activeGame: {
    message: 'You already have an active game.',
    title: 'Active game exists',
    goToGame: 'Go to active game',
  },
  error: {
    title: 'Error occurred',
    generic: 'An error occurred',
    retry: 'Retry',
    connectionFailed: 'Connection failed',
    unknown: 'Unknown error',
    insufficientBalance: 'Insufficient balance',
    cancelSearchFailed: 'Failed to cancel search',
    activeGameIdMissing: 'Cannot open active game: active game id is missing',
    activeGameSlugMissing: 'Cannot open active game: game slug is missing',
    rematchUnavailable: 'Rematch is unavailable: missing lobby id',
    rematchRequestFailed: 'Failed to request rematch',
    rematchDeclined: 'Rematch request was declined',
    rematchUnavailableExpired: 'Rematch request is no longer available',
    rematchCancelFailed: 'Failed to cancel rematch',
    rematchTimedOut: 'Rematch request timed out',
  },
  common: {
    accept: 'Accept',
    decline: 'Decline',
    continue: 'Continue',
    back: 'Back',
    you: 'You',
    opponent: 'Opponent',
  },
  alt: {
    winnerTrophy: 'Winner Trophy',
    sadEmoji: 'Sad emoji',
  },
  game: {
    giveUp: 'Give up',
    mute: 'Mute',
    unmute: 'Unmute',
    howToPlay: 'How to play',
    rulesTitle: '{{gameName}} Rules',
    gotIt: 'Got it',
    turnStamp: {
      yourTurn: 'YOUR TURN',
      opponentTurn: "OPPONENT'S TURN",
    },
    surrender: {
      title: 'Surrender this match?',
      description:
        'If you surrender now, the game will end\nand your opponent will win.\n\nThis action cannot be undone.',
      keepPlaying: 'Keep Playing',
      confirm: 'Surrender',
    },
  },
};
